const { isEmpty } = require('lodash');
const TealiumEventBuilder = require('../../analytics/tealium/builders/tealium-event-builder');

class FulfilmentSelectorDeliveryAddressController {
    constructor($q, settings, addressService, analyticsService, fulfilmentSelectorService) {
        this.$q = $q;
        this.settings = settings;
        this.addressService = addressService;
        this.analyticsService = analyticsService;
        this.fulfilmentSelectorService = fulfilmentSelectorService;
        this.isEmpty = isEmpty;
    }

    $onInit() {
        this.autocompleteText = this.fulfilmentSelectorService.getFullDeliveryAddress(this.selectedAddress);
        this.hasSearched = !!this.autocompleteText && this.autocompleteText.length >= this.settings.fulfilmentSelector.numberOfKeystrokesToTriggerSearch;
        this.activeSearchMode = 'AMAS_ADDRESSES';

        this.screenName = 'FulfilmentSelection';
        const event = new TealiumEventBuilder()
            .withScreenName(this.screenName)
            .withLabel('Fulfilment type toggle')
            .withValue('Delivery')
            .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
            .withEventName('modal_view')
            .withTrackingType('link')
            .build();

        this.analyticsService.push(event);

        this.fulfilmentSelectorService.subscribeEscPushAnalytics(this.analyticsService, this.screenName);
    }

    onAddressSelected(address) {
        if (!this.selectedAddress || (typeof this.selectedAddress.AddressId !== 'undefined' && this.selectedAddress.AddressId !== address.AddressId) || (typeof this.selectedAddress.Id !== 'undefined' && this.selectedAddress.Id !== address.Id)) {
            const event = new TealiumEventBuilder()
                .withScreenName(this.screenName)
                .withLabel('AddressChange')
                .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
                .withEventName('modal_interaction')
                .withTrackingType('link')
                .build();
            this.analyticsService.push(event);
        }
        if (!isEmpty(address)) {
            this.autocompleteText = address.Text ? address.Text : this.fulfilmentSelectorService.getFullDeliveryAddress(address);
            this.hasSearched = !!this.autocompleteText;
            if (typeof address.Id !== 'undefined') {
                this.onSaveAutoAddress({ address });
            } else {
                this.onSavedAddressSelected({ addr: address });
            }
        }
    }

    getItemText(item) {
        return item.Text ? item.Text : item.AddressText;
    }

    openManualAddressForm() {
        const event = new TealiumEventBuilder()
            .withScreenName(this.screenName)
            .withLabel('Button/link click')
            .withValue('Add manually')
            .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
            .withEventName('modal_interaction')
            .withTrackingType('link')
            .build();
        this.analyticsService.push(event);

        this.fulfilmentSelectorService.currentStep = this.fulfilmentSelectorService.fulfilmentSelectorSteps.manualAddress;
    }

    addressOnType() {
        if (!!this.autocompleteText && this.autocompleteText.length >= this.settings.fulfilmentSelector.numberOfKeystrokesToTriggerSearch) {
            this.addressService._clearAutoAddresses();
            return this.addressService.search(this.autocompleteText).then(response => (response ? this.addressService.autoAddresses : []));
        }

        this.selectedAddress = null;

        const deferred = this.$q.defer();
        deferred.resolve(this.savedAddresses);
        return deferred.promise;
    }

    $onDestroy() {
        this.fulfilmentSelectorService.unsubscribeEsc(this.screenName);
    }
}

FulfilmentSelectorDeliveryAddressController.$inject = ['$q', 'Settings', 'AddressService', 'AnalyticsService', 'FulfilmentSelectorService'];

const fulfilmentSelectorDeliveryAddressComponentDefinition = {
    bindings: {
        inputId: '@',
        savedAddresses: '<?',
        onSaveAutoAddress: '&?',
        onSavedAddressSelected: '&?',
        selectedAddress: '=?',
        mandatoryError: '<?',
    },
    controller: FulfilmentSelectorDeliveryAddressController,
    template: require('./fulfilment-selector-delivery-address.component.html').trim(),
};

module.exports = {
    FulfilmentSelectorDeliveryAddressController,
    fulfilmentSelectorDeliveryAddressComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/fulfilmentselector/fulfilment-selector-delivery-address.component.js